import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Collapse
} from "react-bootstrap";
import { IoIosSearch } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { useForm } from 'react-hook-form';
import DateFilterModule from "./SearchForm";
import './PointsBook.css';
import Paginations from "../Pagination/Paginations"

const mockData = [
  { id: 1, type: "Registration", date: "2023-05-01", survey: "--", points: 3000, pending: "--", promo: "--", status: "Billed", balance: 30000 },
  { id: 2, type: "Survey", date: "2023-06-10", survey: "Q1", points: 500, pending: "--", promo: "--", status: "Pending", balance: 30500 },
  { id: 3, type: "Promo", date: "2023-07-01", survey: "--", points: 200, pending: "--", promo: "NEW200", status: "Billed", balance: 30700 },
];

const PointsBook = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showFilters, setShowFilters] = useState(false); // 👈 toggle filter

  const { control, handleSubmit, setValue } = useForm();

  useEffect(() => {
    setData(mockData);
    setFilteredData(mockData);
  }, []);

  const onSubmit = (formData) => {
    const { status, dateRange } = formData;
    let filtered = [...data];

    if (status) {
      filtered = filtered.filter(item => item.status === status.value);
    }

    if (dateRange?.startDate && dateRange?.endDate) {
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.date);
        return itemDate >= new Date(dateRange.startDate) &&
          itemDate <= new Date(dateRange.endDate);
      });
    }

    setFilteredData(filtered);
  };

  const downloadCSV = () => {
    const headers = ["SurveysType", "Date", "Survey", "Points", "Points Pending", "Points Promo Code", "Transaction Type", "Balance"];
    const rows = filteredData.map(row =>
      [row.type, row.date, row.survey, row.points, row.pending, row.promo, row.status, row.balance]
    );

    const csv = [headers, ...rows].map(e => e.join(",")).join("\n");

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "points_book.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const getBadgeClass = (status) => {
    switch (status) {
      case 'Billed':
        return 'bg-success text-white';
      case 'Pending':
        return 'bg-warning text-dark';
      case 'Failed':
        return 'bg-danger text-white';
      case 'Processing':
        return 'bg-info text-white';
      default:
        return 'bg-secondary text-white';
    }
  };


  return (
    <div className="mt-2">
      <h2 className="page-main-title">Points Book</h2>
      <div className="bg-white p-4 rounded shadow mb-4">
        <Row>
          <Col>
          {/* <h5 className="m-0">Points Book</h5><p className="small">Details</p> */}
          </Col>
          <Col style={{ textAlign: 'right' }}>
            <ButtonGroup className="action-header action-pb">
              <Button onClick={() => setShowFilters(prev => !prev)}>
                <IoIosSearch />
              </Button>
              <Button onClick={downloadCSV}><FiDownload /></Button>
            </ButtonGroup>
          </Col>
        </Row>

        {/* 🔽 Slide Toggle Filter */}
        <Collapse in={showFilters}>
          <div>
            <DateFilterModule control={control} setValue={setValue} />
          </div>
        </Collapse>

        <table className="table table-bordered mb-0 mt-1 pb-table">
          <thead className="table-light">
            <tr>
              <th>Type</th>
              <th>Date</th>
              <th>Survey</th>
              <th>Points</th>
              <th>Pending Points </th>
              <th>Promo Code</th>
              <th>Transaction Type</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length ? filteredData.map(row => (
              <tr key={row.id}>
                <td>{row.type}</td>
                <td>{row.date}</td>
                <td>{row.survey}</td>
                <td>{row.points}</td>
                <td>{row.pending}</td>
                <td>{row.promo}</td>
                <td>
                  <span className={`badge ${getBadgeClass(row.status)} pb-badge`}>
                    {row.status}
                  </span>
                </td>
                <td>{row.balance}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="8" className="text-center">No records found.</td>
              </tr>
            )}
          </tbody>
        </table>
        <Paginations
          userlist={100}
          getPageSize={50}
          page={1}
          pagesize={10}
          reloadPagination={true}
        />
      </div>


    </div>
  );
};

export default PointsBook;
